import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import {
  IconButton,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import CoreSpinner from "../../../../app/core/components/CoreSpinner/CoreSpinner";
import CoreStatus from "../../../../app/core/components/CoreStatus/CoreStatus";
import {
  useGetDocumentsQuery,
  useGetPracticeByIdQuery,
  useUploadDocumentsPracticeMutation,
} from "../../../api/user/gestisciPraticheApi";
import FormPratica from "./FormPratica";
import { t } from "i18next";
import CoreButtonHoverIcon from "../../../../app/core/components/CoreButtonIcon/CoreButtonHoverIcon";
import FolderRoundedIcon from "@mui/icons-material/FolderRounded";
import UploadFileRoundedIcon from "@mui/icons-material/UploadFileRounded";
import UnarchiveRoundedIcon from "@mui/icons-material/UnarchiveRounded";
import { useState } from "react";
import { toast } from "react-toastify";
import CoreDialog from "../../../../app/core/components/CoreDialog/CoreDialog";
import { useSelector } from "react-redux";
import CoreBack from "../../../../app/core/components/CoreBack/CoreBack";

const SinglePraticaPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const appConfig = useSelector((state) => state.app.appConfig);

  const [isModal, setIsModal] = useState(false);

  const { data, isLoading } = useGetPracticeByIdQuery(id);

  const { data: datas, isLoading: Loading } = useGetDocumentsQuery(id);

  const [uploadDocuments, { isLoading: loadingUpload }] =
    useUploadDocumentsPracticeMutation();

  const handleUploadDocuments = () => {
    uploadDocuments(id).then((res) => {
      if (res.data.Result === 1) {
        setIsModal(false);
        toast.success("Richiesta inviata");
      } else if (res.data.Exception) {
        toast.error(res.data.Exception);
      }
    });
  };

  if (isLoading) {
    return <CoreSpinner />;
  }

  const statusPractice = data?.Data?.status === "InLavorazione";

  return (
    <div className="flex flex-col h-full w-full">
      <div className="flex justify-center items-center w-full ">
        <CoreBack />
        <div className="w-11/12 flex items-center justify-between">
          <h2 className="fw-bold">{data?.Data?.name}</h2>
          <h5 className="flex items-center uppercase">
            {t("PracticeStatus")}:{" "}
            <span className="ml-2">
              <CoreStatus status={data?.Data?.status} testo />
            </span>
          </h5>
        </div>
      </div>
      <div className="w-full flex ml-4">
        {appConfig?.modules?.practice?.finishLoadingUser && (
          <CoreButtonHoverIcon
            disabled={statusPractice}
            onClick={() => setIsModal(true)}
            className={`m-1 flex flex-row space-x-2 border ${
              statusPractice ? "text-gray" : "text-yellow-500"
            }`}
            testo={t("FinishLoading")}
            icon={
              <UnarchiveRoundedIcon
                className={`${
                  statusPractice ? "text-gray" : "fill-yellow-500"
                }`}
              />
            }
          />
        )}
        <CoreButtonHoverIcon
          className="text-blue-500 m-1 flex flex-row space-x-2 border"
          testo={t("Documents")}
          icon={<FolderRoundedIcon className={`fill-blue-500`} />}
          onClick={() =>
            navigate(
              `/auth/user/${t("singlePracticeRoute")}/${id}/${t("documents")}`
            )
          }
        />
        <CoreButtonHoverIcon
          className="text-green-500 m-1 flex flex-row space-x-2 border"
          testo={t("Upload")}
          icon={<UploadFileRoundedIcon className={`fill-green-500`} />}
          onClick={() =>
            navigate(`/auth/user/${t("uploadDocuments")}/`, {
              state: data?.Data?.id,
            })
          }
        />
      </div>
      <div className="flex w-full mt-5 ml-4">
        <div className="w-4/12 text-center">
          <FormPratica practice={data?.Data} />
        </div>
        <div className="w-8/12 text-center px-16 flex flex-col">
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow style={{ backgroundColor: "silver" }}>
                  <TableCell>{t("Category")}</TableCell>
                  <TableCell>{t("Documents")}</TableCell>

                  <TableCell>{t("Actions")}</TableCell>
                </TableRow>
              </TableHead>
              {datas?.Data?.map((documento) => (
                <TableRow key={documento.id}>
                  <TableCell>{documento.categoryName}</TableCell>
                  <TableCell>{documento.docCount}</TableCell>
                  <TableCell>
                    <Tooltip title={t("Visualize")}>
                      <IconButton
                        onClick={() =>
                          navigate(
                            `/auth/user/${t(
                              "singlePracticeRoute"
                            )}/${id}/documenti?categoria=${
                              documento.categoryId
                            }`
                          )
                        }
                        className="w-10 h-10"
                      >
                        <SearchRoundedIcon />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
              {datas?.Data?.length === 0 && (
                <TableRow>
                  <TableCell colSpan={4} className="text-center text-gray">
                    {t("NoDocs")}
                  </TableCell>
                </TableRow>
              )}
            </Table>
          </TableContainer>
        </div>
      </div>
      <CoreDialog
        open={isModal}
        title={t("FinishLoading")}
        content={t("ConfirmFinishLoading")}
        positiveButton={t("Yes")}
        negativeButton={t("No")}
        handlePositive={handleUploadDocuments}
        closeDialog={() => setIsModal(false)}
        disabledButton={loadingUpload}
      />
    </div>
  );
};

export default SinglePraticaPage;
